
































import PaginateModel from "@/model/paginate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Paginate from "vuejs-paginate";
@Component({
  name: "qEventItemPaginate",
  components: {
    Paginate,
  },
})
export default class QPaginate extends Vue {
  @Prop({ default: true })
  public replaceLocation: boolean;
  @Prop({ default: false })
  public scrollTop: boolean;
  @Prop({
    default: () => {
      return {
        page: 1,
        pageCount: 1,
      };
    },
  })
  public paginate!: PaginateModel;
  public page = 0;

  public mounted(): void {
    this.page = Number.parseInt(this.$router.currentRoute.query.page + "") || 0;
  }

  public changePage(page: any): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, page };

    this.$emit("page-change", query);

    this.replaceLocation &&
      this.$router
        .replace({ name, params, query })
        .catch((error) => {
          console.error(error);
        });
  }

  get pagination(): PaginateModel {
    return this.paginate;
  }

  @Watch("paginate")
  public paginateChanged(newValue: PaginateModel): void {
    this.page !== newValue.page && (this.page = newValue.page);
  }
}
